import { buildPatch } from 'api/builders';

export const update = ({ id, locationId, dispatch }) => buildPatch({
  url: `sign_up/api/locations/${locationId}/pickup_settings/${id}`,
  dispatch,
});
